import { render, staticRenderFns } from "./RequirementsCard.vue?vue&type=template&id=f034fbdc"
import script from "./RequirementsCard.vue?vue&type=script&lang=js"
export * from "./RequirementsCard.vue?vue&type=script&lang=js"
import style0 from "./RequirementsCard.vue?vue&type=style&index=0&id=f034fbdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports